import { CommonButton } from 'components/Button'
import styled from 'styled-components'

import theme from 'theme_'

export const MyAccountFormOuter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MyAccountFormInner = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.spacing.xxl};
  flex-wrap: wrap;

  @media ${theme.devices.tablet} {
    flex-wrap: nowrap;
  }
`

export const MyAccountFormRight = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${theme.devices.tablet} {
    width: 367px;
  }
`

export const MyAccountFormLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const MyAccountFormBtns = styled.div`
  display: flex;
  gap: ${theme.spacing.s};
  margin-top: ${theme.spacing.sm};
  animation: ${theme.animations.fadeIn} 0.3s ease;
`

export const MyAccountFormBtn = styled(CommonButton)`
  min-width: 160px;
`
